// extracted by mini-css-extract-plugin
export default {"item":"transaction-code-item_item__RZFAq","actions":"transaction-code-item_actions__FlPPY"};